@if (formGroup) {
  <div class="flex pt-2" [formGroup]="formGroup">
    <cap-dropdown
      [formControlName]="colorCategoryAttributeName"
      [label]="props.label"
      [options]="colorSystemCategories$ | async"
      [optionLabel]="props.label_key"
      [optionValue]="props.value_key"
      [appendTo]="'body'"
      (changeSelection)="changeColorSystemType()"
      [sortAlphabetically]="false">
      <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
    </cap-dropdown>
    @if (selectedCategory$ | async; as selectedCategory) {
      @switch (selectedCategory.type) {
        @case (InputType.colorSystem) {
          <app-color-system-picker
            [colorCategories]="colorSystemCategories$ | async"
            [selectedColorSystem]="selectedCategory"
            (colorChanged)="updateColorForm($event)">
          </app-color-system-picker>
        }
      }
    }
  </div>
}
